export const TOKEN = 'token'
export const COOKIE_CONSENT_KEY = 'cookie_consent'
export const DEBOUNCE_DELAY = 500

export const MANAGER_PHONE = '+7 (495) 085-82-30'
export const MANAGER_PHONE_HREF = 'tel:+74950858230'

export const APK_APP_URL = process.env.REACT_APP_APK_APP_URL as string
export const DOWNLOAD_ANDROID_APP_LINK = process.env.REACT_APP_DOWNLOAD_ANDROID_APP_LINK as string
export const DOWNLOAD_IOS_APP_LINK = process.env.REACT_APP_DOWNLOAD_IOS_APP_LINK as string
